import { render, staticRenderFns } from "./ScrollingText.vue?vue&type=template&id=0bf40479&scoped=true&lang=pug&"
import script from "./ScrollingText.vue?vue&type=script&lang=js&"
export * from "./ScrollingText.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingText.vue?vue&type=style&index=0&id=0bf40479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf40479",
  null
  
)

export default component.exports